export const LAST_MIDDLE_COLUMN_INDEX = 3;
export const STOCK_PRICE_KEY = 'stock_price';

export const COMPANY_REVENUE_ROW_NUMBER = 11;
export const MULTIPLE_TYPE_ROW_NUMBER = 12;
export const MULTIPLE_PREMIUM_DISCOUNT_ROW_NUMBER = 13;
export const APPLIED_MULTIPLE_ROW_NUMBER = 14;
export const OFFSET_BETWEEN_SELECTION_AND_APPLIED_MULTIPLE = 2;
